'use client';

import { useSyncExternalStore } from 'react';
import { FILE_GRID_BREAKPOINT } from '../../../../constants';

const QUERY = `(min-width: ${FILE_GRID_BREAKPOINT}px)`;

const subscribe = (onChange: () => void) => {
  const media = window.matchMedia(QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

const getSnapshot = () => (window.matchMedia(QUERY).matches ? 2 : 1);
const getServerSnapshot = () => 1;

export const useGridColumnCount = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
